import { Stack } from '@mui/material';
import { styled } from '@mui/material/styles';

export const Wrapper = styled(Stack)`
  flex-direction: row;
  justify-content: space-between;
`;
